// ======================================================================
// FILE:
// src/modules/setup/user_security/services/userSecurityService.js
//
// MODULE:
// Setup
//
// FEATURE:
// User Security APIs
// ======================================================================

import axiosClient from "../../../../api/axiosClient";

// ======================================================================
// SEARCH USERS
// ======================================================================

const searchUsers = async (params = {}) => {

    const res = await axiosClient.get(

        "/api/user-security/users",

        {
            params
        }

    );

    return res.data.data || [];

};

// ======================================================================
// GET USER SECURITY
// ======================================================================

const getUserSecurity = async (mappingId) => {

    const res = await axiosClient.get(

        `/api/user-security/${mappingId}`

    );

    return res.data.data;

};

// ======================================================================
// GET PERMISSIONS
// ======================================================================

// ======================================================================
// GET USER PERMISSIONS
// ======================================================================

const getPermissions = async (
    mappingId
) => {

    const res = await axiosClient.get(

        `/api/user-security/users/${mappingId}/permissions`

    );

    return res.data.data || [];

};

// ======================================================================
// SAVE PERMISSIONS
// ======================================================================

const savePermissions = async (

    mappingId,

    payload

) => {

    const res = await axiosClient.put(

        `/api/user-security/${mappingId}/permissions`,

        payload

    );

    return res.data.data;

};

// ======================================================================
// RESET MODULE
// ======================================================================

const resetModule = async (

    mappingId,

    moduleCode

) => {

    const res = await axiosClient.post(

        `/api/user-security/${mappingId}/reset-module`,

        {

            module_code: moduleCode

        }

    );

    return res.data.data;

};

// ======================================================================
// RESET SINGLE PERMISSION
// ======================================================================

const resetPermission = async (

    mappingId,

    functionalityId

) => {

    const res = await axiosClient.post(

        `/api/user-security/${mappingId}/reset-permission`,

        {

            functionality_id: functionalityId

        }

    );

    return res.data.data;

};
// ======================================================================
// RESET ALL
// ======================================================================

const resetAll = async (mappingId) => {

    const res = await axiosClient.post(

        `/api/user-security/${mappingId}/reset-all`

    );

    return res.data.data;

};

// ======================================================================
// CHANGE PASSWORD
// ======================================================================

const changePassword = async (

    mappingId,

    payload

) => {

    const res = await axiosClient.post(

        `/api/user-security/${mappingId}/change-password`,

        payload

    );

    return res.data.data;

};

// ======================================================================
// RESET PASSWORD
// ======================================================================

const resetPassword = async (

    mappingId,

    payload

) => {

    const res = await axiosClient.post(

        `/api/user-security/${mappingId}/reset-password`,

        payload

    );

    return res.data.data;

};

// ======================================================================
// EXPORT
// ======================================================================

const userSecurityService = {

    searchUsers,

    getUserSecurity,

    getPermissions,

    savePermissions,
    resetPermission,

    resetModule,

    resetAll,

    changePassword,

    resetPassword

};

export default userSecurityService;